<div class="sp-dialog__max-width-m sp-dialog__min-width">
  <div class="sp-width__full sp-row__end">
    <button
      (click)="onCloseClick()"
      mat-icon-button
      class="sp-icon__button sp-icon__button-accent">
      <mat-icon> clear </mat-icon>
    </button>
  </div>

  <div class="sp-padding__x2">
    <h3 class="sp-color__accent">
      {{ 'PRODUCT_SUBCATEGORY.UPDATE_SUBCATEGORY_TITLE' | translate }}
    </h3>
    <form
      [formGroup]="product_subcategory_update_subcategory_from_group"
      class="sp-margin__top-x2">
      <mat-form-field
        class="sp-width__full sp-margin__bottom-x2"
        appearance="fill"
        color="accent">
        <mat-label>
          {{ 'PRODUCT_SUBCATEGORY.NAME_LABEL' | translate }}
        </mat-label>
        <input
          matInput
          type="text"
          formControlName="name"
          required />
      </mat-form-field>

      <mat-checkbox
        formControlName="ecommerce_default"
        class="sp-color__accent">
        {{ 'PRODUCT_SUBCATEGORY.ECOMMERCE_DEFAULT_LABEL' | translate }}
      </mat-checkbox>

      <h3 class="sp-color__warn sp-margin__bottom-x2 sp-text__xs">
        {{ 'PRODUCT_SUBCATEGORY.ECOMMERCE_DEFAULT_INFO_LABEL' | translate }}
      </h3>

      <app-shared-button
        class="sp-width__full sp-margin__top"
        [button_class]="'sp-button__main'"
        [spinner_class]="'sp-spinner__main'"
        [cta]="'GENERAL.CONFIRM_CTA'"
        [is_disabled]="is_submit_running"
        [is_spinner_visible]="is_submit_running"
        (click)="onSubmitClick()"></app-shared-button>
    </form>
  </div>
</div>
